export default (element) => {
  const validateEmail = (email) =>
    String(email)
      .toLowerCase()
      .match(
        // eslint-disable-next-line max-len
        /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|.(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
      );

  const submitNewsletter = () => {
    const form = element.querySelector('#contact_form');
    const submitBtn = form.querySelector('[type="button"]');
    const email = form.querySelector('[name="contact[email]"]');
    submitBtn?.addEventListener('click', (e) => {
      e.preventDefault();
      checkForm(email, form);
    });
    email?.addEventListener('keydown', (e) => {
      console.log('e', e.key);
      if (e.key === 'Enter') checkForm(email, form);
    });
  };

  const checkForm = (email, form) => {
    const error = element.querySelector('[data-error]');
    const errorInput = element.querySelector('[data-error-input]');
    if (!email.value) {
      error.classList.remove('hidden');
      errorInput.classList.remove(
        'focus:border-default',
        'focus:ring-0',
        'border-transparent',
      );
      errorInput.classList.add('border-error', 'border', 'focus:ring-1');
      return;
    }
    if (!validateEmail(email.value)) {
      error.classList.remove('hidden');
      errorInput.classList.remove(
        'focus:border-default',
        'focus:ring-0',
        'border-transparent',
      );
      errorInput.classList.add('border-error', 'border', 'focus:ring-1');
    } else {
      form.submit();
    }
  };

  const scrollToForm = () => {
    const params = new URL(document.location).searchParams;
    const isPosted = params.get('customer_posted');
    if (isPosted) document.location.hash = 'FooterSignUp';
  };

  const init = () => {
    submitNewsletter();
    scrollToForm();
  };

  init();
};
